import { Box, Center, HStack, Text } from "@chakra-ui/react";
import { OrderStatus } from "lib/api/enum";
import { ShippingAddressModel } from "lib/api/model";
import {
    convertDateYYYYMMDDFDot,
    onRegexValidationPhone,
} from "lib/utils/regular";

interface ParcelInfoProps {
    orderStatus: OrderStatus;
    parcelAddressData?: ShippingAddressModel | null;
}

const ParcelInfo = (props: ParcelInfoProps) => {
    const { orderStatus, parcelAddressData } = props;
    const subLabel = () => {
        if (orderStatus <= OrderStatus.MINTING) {
            return "제품 픽업";
        } else {
            return "완료 발송";
        }
    };

    const onSearchParcelInfo = () => {
        var url = "https://info.sweettracker.co.kr/tracking/5";
        // var url = "https://info.sweettracker.co.kr/api/v1/trackingInfo";

        var form = document.createElement("form");
        form.setAttribute("target", "배송조회");
        form.setAttribute("charset", "UTF-8");
        form.setAttribute("method", "Post"); //Post 방식
        form.setAttribute("action", url); //요청 보낼 주소

        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "t_key");
        hiddenField.setAttribute("value", "KovnpwxG1gaVmBNrMCIm4w");
        form.appendChild(hiddenField);

        hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "t_code");
        hiddenField.setAttribute(
            "value",
            `${parcelAddressData?.courier_id.toString().padStart(2, "0")}`
        );
        form.appendChild(hiddenField);

        hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "t_invoice");
        hiddenField.setAttribute("value", `${parcelAddressData?.invoice_num}`);
        form.appendChild(hiddenField);

        document.body.appendChild(form);

        window.open(url, "배송조회");
        form.submit();
    };

    return (
        <Box>
            <HStack
                align="top"
                justify={"space-between"}
                mt={"0rem"}
                mb={"1rem"}
            >
                <Center fontSize={"1rem"} fontWeight="semibold">
                    배송정보
                </Center>
                {parcelAddressData?.invoice_num && (
                    <Center
                        fontSize="0.563rem"
                        fontWeight={"semibold"}
                        bgColor={"#f0fdf5"}
                        color="mint.500"
                        px="0.625rem"
                        py="0.375rem"
                        borderRadius={"md"}
                        onClick={onSearchParcelInfo}
                    >
                        배송 조회
                    </Center>
                )}
            </HStack>
            <Text fontSize="0.813rem" fontWeight={"semibold"} mb="0.625rem">
                {subLabel()}
            </Text>
            <HStack fontSize="0.813rem" fontWeight={"medium"} mb="0.375rem">
                <Text w="5.125rem" color="#757575">
                    방식
                </Text>
                <Text color="#212121">{"택배"}</Text>
            </HStack>
            <HStack fontSize="0.813rem" fontWeight={"medium"} mb="0.5rem">
                <Text w="5.125rem" color="#757575">
                    이름
                </Text>
                <Text color="#212121">{parcelAddressData?.address_name}</Text>
            </HStack>
            <HStack fontSize="0.813rem" fontWeight={"medium"} mb="0.5rem">
                <Text w="5.125rem" color="#757575">
                    연락처
                </Text>
                <Text color="#212121">
                    {onRegexValidationPhone(parcelAddressData?.address_phone!)}
                </Text>
            </HStack>
            <HStack
                fontSize="0.813rem"
                fontWeight={"medium"}
                mb="0.5rem"
                alignItems={"flex-start"}
            >
                <Text w="5.125rem" color="#757575">
                    주소
                </Text>
                <Text
                    flex="1"
                    color="#212121"
                    whiteSpace={"pre-wrap"}
                    wordBreak="break-word"
                >
                    {`${parcelAddressData?.address} ${parcelAddressData?.address_detail}`}
                </Text>
            </HStack>
            <HStack
                fontSize="0.813rem"
                fontWeight={"medium"}
                mb="0.5rem"
                alignItems={"flex-start"}
            >
                <Text w="5.125rem" color="#757575">
                    배송상태
                </Text>
                <Box>
                    {parcelAddressData?.invoice_num ? (
                        <Text
                            flex="1"
                            color="#212121"
                            whiteSpace={"pre-wrap"}
                            wordBreak="break-word"
                        >
                            {parcelAddressData?.courier_id &&
                                `${parcelAddressData?.courier_name} (${parcelAddressData?.invoice_num}}`}
                        </Text>
                    ) : (
                        <Text>준비 중</Text>
                    )}
                    {parcelAddressData?.complete_date! && (
                        <Text color="#212121">
                            {`${convertDateYYYYMMDDFDot(
                                parcelAddressData?.complete_date!
                            )} ${
                                orderStatus <= OrderStatus.MINTING
                                    ? "제품도착"
                                    : "배송완료"
                            }`}
                        </Text>
                    )}
                </Box>
            </HStack>
        </Box>
    );
};

export default ParcelInfo;
